function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "times");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M9.492165,7.5000179 L13.398406,11.4062586 C13.63278,11.640633 13.749967,11.9270905 13.749967,12.2656315 C13.749967,12.6041726 13.63278,12.9036506 13.398406,13.1640669 L12.539033,14.0234398 C12.278616,14.2578143 11.979138,14.3750015 11.640597,14.3750015 C11.302056,14.3750015 11.015599,14.2578143 10.781224,14.0234398 L6.874984,10.1171991 L2.968743,14.0234398 C2.734368,14.2578143 2.447911,14.3750015 2.10937,14.3750015 C1.770829,14.3750015 1.471351,14.2578143 1.210935,14.0234398 L0.351562,13.1640669 C0.117187,12.9036506 0,12.6041726 0,12.2656315 C0,11.9270905 0.117187,11.640633 0.351562,11.4062586 L4.257802,7.5000179 L0.351562,3.5937772 C0.117187,3.3594028 0,3.0729453 0,2.7344042 C0,2.3958632 0.117187,2.0963851 0.351562,1.8359689 L1.210935,0.9765959 C1.471351,0.7422215 1.770829,0.6250343 2.10937,0.6250343 C2.447911,0.6250343 2.734368,0.7422215 2.968743,0.9765959 L6.874984,4.8828366 L10.781224,0.9765959 C11.015599,0.7422215 11.302056,0.6250343 11.640597,0.6250343 C11.979138,0.6250343 12.278616,0.7422215 12.539033,0.9765959 L13.398406,1.8359689 C13.63278,2.0963851 13.749967,2.3958632 13.749967,2.7344042 C13.749967,3.0729453 13.63278,3.3594028 13.398406,3.5937772 L9.492165,7.5000179 Z",
  id: "t"
})));

var SvgTimes = function SvgTimes(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 14 15",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTimes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/times.91fb5951.svg";
export { ForwardRef as ReactComponent };